import { EventEmitter, Injectable, Output } from "@angular/core";
import { Overlay, OverlayRef } from "@angular/cdk/overlay";
import { ComponentPortal } from "@angular/cdk/portal";
import { SnackBarComponent } from "../components/shared/snackbar/snackbar-component";
import { Severity, SnackbarMessage } from "../model/snackbar";

@Injectable()
export class SnackBarService {
    private overlayRef: OverlayRef | null = null;
    private toastContainerRef: SnackBarComponent | null = null;

    constructor(private overlay: Overlay) { }

    private createOverlay() {
        const overlayRef = this.overlay.create({
            hasBackdrop: false,
            panelClass: 'toast-cdk-panel',
            scrollStrategy: this.overlay.scrollStrategies.noop(),
            positionStrategy: this.overlay.position().global().top('10px').right('10px')
        });

        const portal = new ComponentPortal(SnackBarComponent);
        const toastRef = overlayRef.attach(portal).instance;

        overlayRef.overlayElement.style.zIndex = '20000';

        toastRef.onAllToastsClosed.subscribe(() => {
            overlayRef.dispose();
            this.overlayRef = null;
            this.toastContainerRef = null;
        });

        return { overlayRef, toastRef };
    }

    private ensureOverlay() {
        if (!this.overlayRef || !this.overlayRef.hasAttached()) {
            const { overlayRef, toastRef } = this.createOverlay();
            this.overlayRef = overlayRef;
            this.toastContainerRef = toastRef;
        }
    }

    private showToast(msg: string, severity: Severity) {
        this.ensureOverlay();
        this.toastContainerRef!.showToast(new SnackbarMessage(msg, severity));
    }

    sendSuccess(msg: string) { this.showToast(msg, Severity.SUCCESS); }
    sendInfo(msg: string) { this.showToast(msg, Severity.INFO); }
    sendWarn(msg: string) { this.showToast(msg, Severity.WARNING); }
    sendError(msg: string) { this.showToast(msg, Severity.ERROR); }
}
